import logger from './logger';

/**
 * The funnel's checkout outcome, confirmed by our own server.
 *
 * Stripe Embedded Checkout tells the page it completed through a callback
 * in the browser. The welcome goes up on that word (it is Stripe's own
 * iframe); the page then has the backend read the Checkout Session back from
 * Stripe (GET /checkout-session/{id}, owner-only) so analytics can tell a
 * verified completion from an unverified one. RevenueCat, not the page,
 * remains the source of truth for the entitlement itself.
 */

export const checkoutSessionPaid = (data) =>
  !!data && (
    data.status === 'complete'
    || data.payment_status === 'paid'
    || data.payment_status === 'no_payment_required'
  );

const defaultSleep = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

export async function confirmCheckoutSession(apiClient, sessionId, { attempts = 4, delayMs = 1200, sleep = defaultSleep } = {}) {
  if (!apiClient?.getCheckoutSession || !sessionId) return false;
  for (let attempt = 0; attempt < attempts; attempt += 1) {
    try {
      const res = await apiClient.getCheckoutSession(sessionId);
      if (res?.status && checkoutSessionPaid(res.data)) return true;
    } catch (error) {
      logger.warn('Checkout confirmation attempt failed (non-blocking):', error?.name || 'Error');
    }
    if (attempt < attempts - 1) await sleep(delayMs);
  }
  return false;
}
